import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "geolocation-debug"
}

import { computed, watch } from 'vue';
import { VBtn } from 'vuetify/components/VBtn';
import { useGeolocation } from './geolocation';

type Density = null | 'default' | 'comfortable' | 'compact';

export interface GeolocationProps {
  color?: string;
  debug?: boolean;
  disabled?: boolean;
  size?: string;
  density?: Density;
  elevation?: string;
  showCoords?: boolean;
  showLoading?: boolean;
  id?: string | null;
  trueIcon?: string;
  falseIcon?: string;
  backgroundColor?: string;
  showPermissions?: boolean;
}

// Define props with default values using withDefaults

export default /*@__PURE__*/_defineComponent({
  __name: 'GeolocationButton',
  props: {
    color: { default: 'white' },
    debug: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { default: 'small' },
    density: { default: 'comfortable' },
    elevation: { default: "2" },
    showCoords: { type: Boolean, default: false },
    showLoading: { type: Boolean, default: true },
    id: { default: '' },
    trueIcon: { default: 'mdi-crosshairs-gps' },
    falseIcon: { default: 'mdi-crosshairs' },
    backgroundColor: { default: 'black' },
    showPermissions: { type: Boolean, default: false }
  },
  emits: ['location'],
  setup(__props: any, { emit: __emit }) {

const props = __props;



const { 
  isSupported, // If geolocation is supported in the browser
  isPermissionGranted, // If the user has granted geolocation permission
  isPermissionDenied, // If the user has denied geolocation permission
  isPermissionPrompt, // If the user has not yet been prompted for geolocation permission
  permissionsRequested, // flag that we have requested permissions
  checkingPermissions, // flag that we are checking the permissions
  isLoading, // flag that we are getting the location
  error, // error object if there was an error
  hasError, // flag that there was an error
  geolocationSuccess, // flag that we have successfully gotten the location
  position, // object with latitude and longitude
  getCurrentLocation, // function to get the current location
} = useGeolocation(true);

const icon = computed(() => geolocationSuccess.value ? props.trueIcon : props.falseIcon);


const emits = __emit;

watch(position, (newVal) => {
  if (newVal) {
    emits('location', newVal);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    id: 'geolocation-wrapper' + (__props.id ? '_' : '') + __props.id,
    class: "jl_geolocation"
  }, [
    _createVNode(_unref(VBtn), {
      class: "geolocation-button",
      density: __props.density,
      size: __props.size,
      variant: "flat",
      elevation: __props.elevation,
      loading: _unref(isLoading),
      icon: icon.value,
      color: _unref(hasError) ? 'red' : __props.color,
      onClick: _withModifiers(_unref(getCurrentLocation), ["stop"])
    }, null, 8, ["density", "size", "elevation", "loading", "icon", "color", "onClick"]),
    (__props.debug)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, "isSupported: " + _toDisplayString(_unref(isSupported)), 1),
            _createElementVNode("div", null, "permissionsRequested: " + _toDisplayString(_unref(permissionsRequested)), 1),
            _createElementVNode("div", null, "isPermissionGranted: " + _toDisplayString(_unref(isPermissionGranted)), 1),
            _createElementVNode("div", null, "isPermissionDenied: " + _toDisplayString(_unref(isPermissionDenied)), 1),
            _createElementVNode("div", null, "isPermissionPrompt: " + _toDisplayString(_unref(isPermissionPrompt)), 1),
            _createElementVNode("div", null, "checkingPermissions: " + _toDisplayString(_unref(checkingPermissions)), 1),
            _createElementVNode("div", null, "isLoading: " + _toDisplayString(_unref(isLoading)), 1),
            _createElementVNode("div", null, "error: " + _toDisplayString(_unref(error)), 1),
            _createElementVNode("div", null, "hasError: " + _toDisplayString(_unref(hasError)), 1),
            _createElementVNode("div", null, "geolocationSuccess: " + _toDisplayString(_unref(geolocationSuccess)), 1),
            _createElementVNode("div", null, "position: " + _toDisplayString(_unref(position)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})